import { apiOperacao } from "../../api";
import { newIImportInfo } from "../../model";
import * as utils from "../../utils";
import { ResultadoStore } from "../resultados/ResultadoStore";

export class _SummaryService {

  async summary(operacao: string,importacao_id: string, tipo: string, modelo: string) {

    try {

      ResultadoStore.obs.isValida = false;
      ResultadoStore.obs.contestacao_summary = newIImportInfo();

      let data = {
        contestacao_id: importacao_id,
        tipo: tipo,
        modelo: modelo
      }

      let resp = await apiOperacao(operacao).post(`/${operacao}/summary`, data);

      if (Array.isArray(resp.data)) {

        ResultadoStore.obs.isValida = true

      } else {

        ResultadoStore.obs.isValida = false;
        ResultadoStore.obs.contestacao_summary = resp.data

      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao consultar detalhes Contestação, tente novamente mais tarde.`);

    }

  }

  async busca_erros_summary(operacao: string,contestacao_id: string) {

    try {

      ResultadoStore.obs.erros_contestacao = []

      let data = { contestacao_id: contestacao_id, }

      let resp = await apiOperacao(operacao).post(`/${operacao}/erros`, data);

      if (resp.data.length > 0) {

        resp.data?.map(values => {

          values.itens?.map(erros => {

            ResultadoStore.obs.erros_contestacao.push(erros);
          })

        })

      } else {

        ResultadoStore.obs.erros_contestacao = []

      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao consultar erros Contestação, tente novamente mais tarde.`);

    }

  }

}

export const SummaryService = new _SummaryService();
